import CovidInfoPage from "./CovidInfoPage";

export default CovidInfoPage;